// extracted by mini-css-extract-plugin
export default {"carousel":"AI-z"};